export const TAB_STYLES = {
  base: 'rounded-none pb-[9px] !uppercase text-giveaway-text-subtle-light hover:!text-black border-b-transparent border-b-[3px] focus:outline-none focus:ring-0 focus:ring-transparent focus:right-offset-0',
  get multi() {
    return this.base + ' ui-selected:border-giveaway-primary-subtle ui-selected:!text-giveaway-text-primary-dark'
  },
  active: '!border-b-giveaway-primary-subtle !border-b-[3px] !text-giveaway-text-primary-dark',
  disabled: '!opacity-80 cursor-not-allowed hover:!text-giveaway-subtle',
} as const

export const SCROLL_BEHAVIOR_CONFIG = {
  behavior: 'smooth' as const,
  block: 'start' as const,
}
